import { css } from "../../../styled-system/css";

export const styles = {
  arrow: (disabled?: boolean) =>
    css({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      backgroundColor: disabled ? "lightGrey" : "skyBlue",
      border: "none",
      cursor: disabled ? "default" : "pointer",
      pointerEvents: disabled ? "none" : "auto",
      transition: "background-color 0.2s ease",
      outline: "none",
      _hover: {
        backgroundColor: disabled ? "lightGrey" : "oceanBlue",
      },
      _focusVisible: {
        boxShadow: "0px 0px 0px 2px white, 0px 0px 0px 4px token(colors.oceanBlue)",
      },
    }),

  icon: () =>
    css({
      width: "20px",
      height: "20px",
      color: "white",
    }),
};
